import React from "react";
import { verifyRegister } from "../../../services/common/action"
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import '../../../assets/css/custom.css'

class VerifyRegister extends React.Component {


    componentDidMount() {
        let path = window.location.href.split("=")
        let email = path[1]

        let emailId = {
            email
        }

        this.props.verifyRegister(emailId);
    }
    //    {message &&
    //             <h1> {message} </h1>
    //             }

    //             {error && 
    //              <h1> {message} </h1>
    //             }

    //             {warning && 
    //              <h1> {warning} </h1>
    //             } 
 

    render() {
        let message = this.props.message
  
        



        return (
             
             
           // email-icon

                <div className="email-verify">
                    <div className="email-box">
                        <div className="emailverify-box">
                            <div className="email-content" >
                                <div className={message === "email was successfully verified" ? "email-icon green": message === "Email ID is Not Exist!" ? "email-icon red" : message === "Email ID Already Verified!" ? "email-icon yellow" :""} ></div>
                               {message === "email was successfully verified"  &&  
                                <h1 className={message === "email was successfully verified" ? "green1": message === "Email ID is Not Exist!" ? "red" : message === "Email ID Already Verified!" ? "yellow" :""}>
                                  Thank You</h1>
                               }
                               {message === "Email ID Already Verified!"  &&  
                                <h1 className={message === "email was successfully verified" ? "green1": message === "Email ID is Not Exist!" ? "red" : message === "Email ID Already Verified!" ? "yellow" :""}>
                                  Hey</h1>
                               }
                                {message === "Email ID is Not Exist!"  &&  
                                <h1 className={"red"}>
                                  Sorry</h1>
                               }
                                <h3 className={message === "email was successfully verified" ? "green1": message === "Email ID is Not Exist!" ? "red" : message === "Email ID Already Verified!" ? "yellow" :""}>
                                  Your {message  }</h3>
                                <a  href="/"  >
                               { message === "Email ID is Not Exist!" ?  "Click here to Register" : "Click here to login" } </a>
                            </div>
                        </div>
                    </div>
                </div>
             
        )
    }
}

const mapStateToProps = state => ({
    verifyRegisterStatus: state.commonReducer.verifyRegisterStatus,
    message: state.commonReducer.message,
  


});

const mapDispatchToProps = dispatch => ({
    verifyRegister: (email) => dispatch(verifyRegister(email)),

});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(VerifyRegister));